"use strict";

var _interopRequireDefault = require("/code/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/code/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.number.is-integer");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _treatmentpartadjust = require("@/api/treatmentpartadjust");
var _org = require("@/api/org");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var defaultTreatmentPartAdjust = {
  quantity: '',
  receiving_medical_no: '',
  receiving_medical_name: '',
  receipt_dept_id: '',
  receipt_dept_name: ''
};
var defaultApprovalAdjust = {
  approval_status: null,
  remark: ''
};
var checkNumber = function checkNumber(rule, value, callBack) {
  if (!Number.isInteger(value)) {
    callBack(new Error('请输入合法的整数值'));
  } else {
    if (value < 0) {
      callBack(new Error('数量不能小于0'));
    } else {
      callBack();
    }
  }
};
var _default = exports.default = {
  data: function data() {
    return {
      dialogTransformLoading: false,
      transformData: {
        results: []
      },
      viewDialog1: false,
      listLoading: true,
      tableData: [],
      treatmentpartadjust: defaultTreatmentPartAdjust,
      treatmentapprovaladjust: defaultApprovalAdjust,
      dialogVisible: false,
      approvalDialog: false,
      viewDialog: false,
      dialogType: 'new',
      number: '',
      rule1: {
        quantity: [{
          required: true,
          message: '请输入调理部位数量',
          trigger: 'bur'
        }, {
          validator: checkNumber
        }],
        receiving_medical_no: [{
          required: true,
          message: '请输入收货部门编号',
          trigger: 'blur'
        }],
        receipt_dept_id: [{
          required: true,
          message: '请输入出货部门编号',
          trigger: 'blur'
        }]
      },
      rule2: {
        approval_status: [{
          required: true,
          message: '请选择审核状态',
          trigger: 'change'
        }],
        remark: [{
          max: 200,
          message: '输入长度不能超过200位',
          trigger: 'blur'
        }]
      },
      statusOptions: [{
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '拒绝'
      }, {
        value: 3,
        label: '完成'
      }],
      typeOptions: [{
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      typeOptions1: [{
        value: 1,
        label: '待审核'
      }, {
        value: 2,
        label: '拒绝'
      }, {
        value: 3,
        label: '通过'
      }],
      listQuery: {
        page: 1,
        page_size: 10
      },
      orgList: []
    };
  },
  created: function created() {
    this.getList();
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      console.log("\u6BCF\u9875 ".concat(val, " \u6761"));
      this.listQuery.page_size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      console.log("\u5F53\u524D\u9875: ".concat(val));
      this.listQuery.page = val;
      this.getList();
    },
    checkPermission: _permission.default,
    handleAdd: function handleAdd() {
      var _this = this;
      this.treatmentpartadjust = Object.assign({}, defaultTreatmentPartAdjust);
      this.dialogType = 'new';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this.$refs['Form'].clearValidate();
      });
    },
    getList: function getList() {
      var _this2 = this;
      this.listLoading = true;
      (0, _treatmentpartadjust.getTreatmentPartAdjustList)(this.listQuery).then(function (response) {
        if (response.data) {
          // console.log(response.data)
          _this2.tableData = response.data;
        }
        _this2.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleEdit: function handleEdit(scope) {
      var _this3 = this;
      this.treatmentpartadjust = Object.assign({}, scope.row); // copy obj
      this.dialogType = 'edit';
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this3.$refs['Form'].clearValidate();
      });
    },
    handleDelete: function handleDelete(scope) {
      var _this4 = this;
      this.$confirm('确认删除?', '警告', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'error'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _treatmentpartadjust.deleteTreatmentPartAdjust)(scope.row.id);
            case 2:
              // this.tableData.splice($index, 1)
              _this4.getList();
              _this4.$message({
                type: 'success',
                message: '成功删除!'
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))).catch(function (err) {
        console.error(err);
      });
    },
    handleView: function handleView(scope) {
      this.treatmentpartadjust = Object.assign({}, scope.row);
      this.viewDialog1 = true;
      this.transformData.results[0] = this.treatmentpartadjust;
      console.log(this.transformData);
    },
    handleApproval: function handleApproval(scope) {
      var _this5 = this;
      this.treatmentpartadjust = Object.assign({}, scope.row);
      this.treatmentapprovaladjust = Object.assign({}, defaultApprovalAdjust);
      this.approvalDialog = true;
      this.$nextTick(function () {
        _this5.$refs['approvalForm'].clearValidate();
      });
    },
    getName: function getName() {
      var _this6 = this;
      console.log(this.treatmentpartadjust.receiving_medical_no);
      if (this.treatmentpartadjust.receiving_medical_no) {
        this.listQuery.dept_no = this.treatmentpartadjust.receiving_medical_no;
        (0, _org.getOrgList)(this.listQuery).then(function (response) {
          if (response.data) {
            console.log(response.data);
            _this6.treatmentpartadjust.receiving_medical_name = response.data[0].name;
          } else {
            _this6.treatmentpartadjust.receiving_medical_name = '';
          }
        });
      } else {
        this.treatmentpartadjust.receiving_medical_name = '';
      }
      console.log(this.treatmentpartadjust.receiving_dept_name);
    },
    getReceiptName: function getReceiptName() {
      var _this7 = this;
      console.log(this.treatmentpartadjust.receipt_dept_id);
      if (this.treatmentpartadjust.receipt_dept_id) {
        this.listQuery.dept_no = this.treatmentpartadjust.receipt_dept_id;
        (0, _org.getOrgList)(this.listQuery).then(function (response) {
          if (response.data) {
            console.log(response.data);
            _this7.treatmentpartadjust.receipt_dept_name = response.data[0].name;
          } else {
            _this7.treatmentpartadjust.receipt_dept_name = '';
          }
        });
      } else {
        this.treatmentpartadjust.receipt_dept_name = '';
      }
      console.log(this.treatmentpartadjust.receipt_dept_name);
    },
    confirm: function () {
      var _confirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(form) {
        var _this8 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  var isEdit = _this8.dialogType === 'edit';
                  if (isEdit) {
                    (0, _treatmentpartadjust.updateTreatmentPartAdjust)(_this8.treatmentpartadjust.id, _this8.treatmentpartadjust).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '编辑成功',
                        type: 'success'
                      });
                    });
                  } else {
                    (0, _treatmentpartadjust.createTreatmentPartAdjust)(_this8.treatmentpartadjust).then(function (res) {
                      _this8.getList();
                      _this8.dialogVisible = false;
                      _this8.$message({
                        message: '新增成功',
                        type: 'success'
                      });
                    });
                  }
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function confirm(_x) {
        return _confirm.apply(this, arguments);
      }
      return confirm;
    }(),
    confirmApproval: function () {
      var _confirmApproval = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(form) {
        var _this9 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.$refs[form].validate(function (valid) {
                if (valid) {
                  (0, _treatmentpartadjust.approvalTreatmentPartAdjust)(_this9.treatmentpartadjust.id, _this9.treatmentapprovaladjust).then(function (res) {
                    if (_this9.treatmentapprovaladjust.approval_status === 1) {
                      _this9.getList();
                      _this9.approvalDialog = false;
                      _this9.$message({
                        message: '审核通过',
                        type: 'success'
                      });
                    } else if (_this9.treatmentapprovaladjust.approval_status === 2) {
                      _this9.getList();
                      _this9.approvalDialog = false;
                      _this9.$message({
                        message: '审核拒绝',
                        type: 'danger'
                      });
                    }
                  });
                } else {
                  return false;
                }
              });
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function confirmApproval(_x2) {
        return _confirmApproval.apply(this, arguments);
      }
      return confirmApproval;
    }()
  }
};